import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { CountdownRing } from '../CountdownRing';
import { touchpoints } from '../../data/deckContent';

/** Evenly spaced points on a ring, starting at the top. */
const positions = touchpoints.map((_, i) => {
  const angle = i / touchpoints.length * Math.PI * 2 - Math.PI / 2;
  return {
    left: `${50 + Math.cos(angle) * 42}%`,
    top: `${50 + Math.sin(angle) * 42}%`,
    x1: 50 + Math.cos(angle) * 34,
    y1: 50 + Math.sin(angle) * 34,
    x2: 50 + Math.cos(angle) * 15,
    y2: 50 + Math.sin(angle) * 15
  };
});
export function EcosystemSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="The ecosystem" index={11} showMiniCountdown={false} chapter="tactics" data-id="element-69" data-mp="10z7h99y91nsk">
      <div className="grid grid-cols-[1fr_0.95fr] items-center gap-[4%]" data-id="element-70" data-mp="37qf9jsksa34x">
        <div data-id="element-71" data-mp="32rvnls66wrck">
          <h2 className="max-w-[18ch] text-[clamp(24px,3.4vw,60px)] font-semibold leading-[1.06] tracking-tight text-white" data-id="element-72" data-mp="32s3yxfmnzoln">
            The campaign is not the channel.
          </h2>

          <p className="mt-[3.5vh] text-[clamp(15px,1.9vw,36px)] font-light leading-tight text-white" data-id="element-73" data-mp="3480de4ekqmui">
            The media changes.
            <br data-id="element-74" data-mp="394qoedbius92" />
            <span className="font-medium text-[color:var(--sv-green)]" data-id="element-75" data-mp="3947bxc4n4w2f">
              The promise doesn’t.
            </span>
          </p>

          <p className="mt-[3vh] max-w-[42ch] text-[clamp(11px,1.15vw,22px)] font-light leading-snug text-white/55" data-id="element-76" data-mp="3hz57kqz6amxg">
            A recognizable Solventum experience wherever the HCP encounters it.
          </p>
        </div>

        <div className="relative mx-auto aspect-square w-full max-w-[min(40vw,64vh)]" data-id="element-77" data-mp="3rx2qr026dtj7">
          <svg aria-hidden="true" viewBox="0 0 100 100" className="absolute inset-0 h-full w-full" data-id="element-78" data-mp="oxckbs4y4yc">
            <circle cx="50" cy="50" r="34" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="0.4" data-id="element-79" data-mp="22hli4rs954ha" />
            {positions.map((p, i) => <line key={i} x1={p.x1} y1={p.y1} x2={p.x2} y2={p.y2} stroke="var(--sv-green)" strokeOpacity="0.4" strokeWidth="0.35" data-id="element-80" data-mp="1pivrlrvipd3w" data-mpi={i} />)}
          </svg>

          <div className="absolute left-1/2 top-1/2 flex aspect-square w-[30%] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full border border-[color:var(--sv-green)]/45 bg-[color:var(--sv-bg)]" data-id="element-81" data-mp="2degnzsmfph7l">
            <div className="w-[62%]" data-id="element-82" data-mp="2n7nop068c91c">
              <CountdownRing size="sm" data-id="element-83" data-mp="2i5ygrteb0bhh" />
            </div>
            <span className="mt-[0.8vh] text-[clamp(7px,0.7vw,13px)] uppercase tracking-[0.22em] text-[color:var(--sv-green)]" data-id="element-84" data-mp="2i8kuybvp9p8o">
              The Snak
            </span>
          </div>

          {touchpoints.map((point, i) => <motion.span key={point} initial={reduced ? false : {
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.05 * i,
          ease: [0.23, 1, 0.32, 1]
        }} style={{
          left: positions[i].left,
          top: positions[i].top
        }} className="absolute -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full border border-white/14 bg-[color:var(--sv-bg)] px-[0.9vw] py-[0.8vh] text-[clamp(8px,0.8vw,15px)] font-medium uppercase tracking-[0.2em] text-white/75" data-id="element-85" data-mp="3at7yap6ncggb" data-mpi={i}>
              {point}
            </motion.span>)}
        </div>
      </div>
    </SlideFrame>;
}